const Bradesco = () => {
  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2217_6341)'>
        <path
          d='M9.84752 10.3242L8.52944 11.0801V15.9193L9.94531 15.9212C10.0846 15.9215 10.1976 15.8089 10.1976 15.6703V10.5046C10.1976 10.3067 10.0057 10.2345 9.84752 10.3242ZM7.93547 3.40632C6.95927 3.40632 5.8923 3.49581 4.83788 3.6743C5.9051 2.30939 7.59695 1.42895 9.4839 1.42895C10.8764 1.42895 12.269 1.95192 13.2061 2.73012C13.3754 2.87037 13.5055 2.88336 13.6357 2.75562C13.7658 2.62813 13.7528 2.50039 13.6096 2.33465C12.3862 0.918494 10.5902 -0.0381956 8.46883 5.24521e-05C5.69672 0.0512905 3.34112 1.79893 2.44316 4.22277C1.62318 4.478 0.868407 4.78399 0.204655 5.15396C0.022359 5.2562 -0.0425916 5.38369 0.022359 5.53669C0.0875511 5.67693 0.217693 5.72793 0.399748 5.67693C0.972472 5.51095 1.55799 5.3707 2.16959 5.24321C2.1044 5.56219 2.06553 5.89391 2.06553 6.23839C2.01337 8.47099 3.21073 10.5886 5.05881 11.7495C5.2411 11.8645 5.39732 11.8645 5.50139 11.724C5.60545 11.5838 5.59242 11.4563 5.4362 11.3158C4.26491 10.2696 3.6142 8.71323 3.6142 7.16958C3.6142 6.39138 3.77042 5.63868 4.06982 4.96248C4.68142 4.91148 5.34517 4.87323 6.07411 4.87323C10.8114 4.87323 14.8067 6.42963 14.8067 8.47075C14.8067 9.50418 13.4922 10.5374 11.9305 11.2263C11.5531 11.3921 11.514 11.5068 11.5662 11.6728C11.6181 11.8258 11.7874 11.877 11.9827 11.813C14.7159 10.9203 16.7852 9.45342 16.7852 7.68004C16.7852 5.26895 12.8809 3.40632 7.93547 3.40632ZM6.92499 12.1873V15.7596C6.92499 15.8491 6.99766 15.9215 7.08749 15.9215H8.08492V11.3346L7.08918 11.9056C6.98752 11.9634 6.92499 12.0541 6.92499 12.1873Z'
          fill='#CE1C30'
        />
      </g>
      <defs>
        <clipPath id='clip0_2217_6341'>
          <rect
            width='17'
            height='16'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Bradesco
